import './parts/nav'

let toggle = document.getElementById('darklight-switch')
if (toggle) darkModeSwitch(toggle)

function darkModeSwitch(toggle: HTMLElement) {
    const setTheme = (isDarkMode: boolean) => {
        toggle.setAttribute('aria-checked', isDarkMode ? 'true' : 'false')
        localStorage.setItem('theme', isDarkMode ? 'dark' : 'light')
        document.body.classList.toggle('dark-mode', isDarkMode)
    }

    let isDarkMode = localStorage.getItem('theme') === 'dark'
    setTheme(isDarkMode)

    toggle.addEventListener('click', () => {
        isDarkMode = !isDarkMode
        setTheme(isDarkMode)
    })
}
